import React, { useState, useEffect, useCallback, useRef }  from 'react';
import Card from 'react-bootstrap/Card';
import { Link, useParams, Redirect } from 'react-router-dom';
import { useWindowSize } from './hooks/useWindowSize';

function PreviewPage({ accessToken, getVideoSubtitles, getCurrentSubtitles }) {   
    const [player, setPlayer] = useState(null);
    const [currentVideoID, setCurrentVideoID] = useState();
    const currentVideoIDRef = useRef(null);
    const [currentPlaylistID, setCurrentPlaylistID] = useState();
    const [videoUrl, setVideoUrl] = useState('');
    const [allLanguages, setAllLanguages] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [videoSubtitles, setVideoSubtitles] = useState({});
    const [currentSubtitles, setCurrentSubtitles] = useState([]);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [currentTime, setCurentTime] = useState();    
    const [subtitleStyle, setSubtitleStyle] = useState({});
    const [playerReady, setPlayerReady] = useState(false);    
    const windowSize = useWindowSize();
    const containerRef = useRef();
    let currentPlayer;
    let youTubeApiInitialised = false;
    let intervalHandle;

    useEffect(
        () => {
            if(!youTubeApiInitialised) {
                initialiseIFrameAPI();
                youTubeApiInitialised = true;
            }
            handleFullScreenChange();
            return function cleanup() {
                if(intervalHandle) {
                    clearInterval(intervalHandle);
                }
                cancelHandleFullScreenChange();
            };
        }, []
      );

      useEffect(() => {
        if(currentVideoID) {
            newVideoLoaded();
            currentVideoIDRef.current = currentVideoID;
        }
      }, [currentVideoID])

      useEffect(() => {
        if(currentPlaylistID && player.cuePlaylist) {
            player.cuePlaylist({ listType: 'playlist', list: currentPlaylistID });
        }
      }, [currentPlaylistID, player])

      useEffect(() => {
        if(isFullScreen) {
            makeFullScreen();
          }
          else {
            cancelFullScreen();
          }
      }, [isFullScreen])

      useEffect(() => {
        if(currentTime != null) {
            updateCurrentSubtitles();
        }
      }, [currentTime])

      useEffect(() => {
        setSubtitleStyle(getSubtitleStyle());
    }, [windowSize, currentVideoID])

    const newVideoLoaded = async () => {
        const subtitles = await getVideoSubtitles(accessToken, currentVideoID);
        setVideoSubtitles(subtitles);
        const languages = Object.keys(subtitles || {});
        setAllLanguages(languages);
        setSelectedLanguages(languages);
    }

    const handleFullScreenChange = () => {
        if (document.addEventListener) {
            document.addEventListener('fullscreenchange', fullScreenExitHandler, false);
            document.addEventListener('mozfullscreenchange', fullScreenExitHandler, false);
            document.addEventListener('MSFullscreenChange', fullScreenExitHandler, false);
            document.addEventListener('webkitfullscreenchange', fullScreenExitHandler, false);
        }
    }

    const cancelHandleFullScreenChange = () => {
        if (document.removeEventListener) {
            document.removeEventListener('fullscreenchange', fullScreenExitHandler, false);
            document.removeEventListener('mozfullscreenchange', fullScreenExitHandler, false);
            document.removeEventListener('MSFullscreenChange', fullScreenExitHandler, false);
            document.removeEventListener('webkitfullscreenchange', fullScreenExitHandler, false);
        }
    }

    const fullScreenExitHandler = () => {
        if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement)
        {
            setIsFullScreen(false);
        }
    }

    const initialiseIFrameAPI = () => {      
        if (!window.YT) { // If not, load the script asynchronously
            const tag = document.createElement('script');
            tag.id = 'iframe-script';
            tag.src = '//www.youtube.com/iframe_api';
            window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        } 
        else if(!player && window.YT.Player) { // If script is already there, load the video directly
            onYouTubeIframeAPIReady();
        }
    }                
    
    const onYouTubeIframeAPIReady = () => {
        const youTubePlayer = new window.YT.Player('player', {
            videoId: '',
            playerVars: {
                autoplay: 0,
                playsInline: 1
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
        setPlayer(youTubePlayer);
        currentPlayer = youTubePlayer;
    }

    const makeFullScreen = () => {    
        try {
          if(containerRef && document.fullscreenEnabled) {
            const container = containerRef.current;
            if (container.requestFullscreen) {
              container.requestFullscreen();
            } 
            else if (container.mozRequestFullScreen) {
              /* Firefox */
              container.mozRequestFullScreen();
            } 
            else if (container.webkitRequestFullscreen) {
              /* Chrome, Safari & Opera */
              container.webkitRequestFullscreen();
            } 
            else if (container.msRequestFullscreen) {
              /* IE/Edge */
              container.msRequestFullscreen();
            }
          }
        }
        catch(err) {}
      }
    
    const cancelFullScreen = () => {
        try {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }
        }
        catch(err) {}
    }    
    
    const updateCurrentSubtitles = () => {
        if(currentTime !== null) {
            const currentSubtitles = getCurrentSubtitles(videoSubtitles, selectedLanguages, currentTime);
            setCurrentSubtitles(currentSubtitles);
        }
    }

    const setCurrentTimeInterval = () => {
        if(!intervalHandle) {
            intervalHandle = setInterval(() => {
                const myPlayer = player || currentPlayer;
                const videoID = myPlayer.getVideoData().video_id;
                if(myPlayer && videoID) {
                    let playedSecs = myPlayer.getCurrentTime();
                    setCurentTime(playedSecs);
                }
            }, 500);
        }
    }  

    const onPlayerReady = (event) => {
        setPlayerReady(true);
        if(player && player.getPlayerState() === window.YT.PlayerState.PLAYING) {
            debugger;
            setCurrentTimeInterval();
        }
    }    

    const onPlayerStateChange = (event) => {
        const playerStatus = event.data;    
        if(playerStatus === window.YT.PlayerState.PLAYING && !intervalHandle) {
            setCurrentTimeInterval();
        }
        else if(intervalHandle) {
            clearInterval(intervalHandle);
            intervalHandle = null;
            setCurrentSubtitles([]);
        }        
        const myPlayer = player || currentPlayer;
        const videoID = myPlayer.getVideoData().video_id;
        if((playerStatus === window.YT.PlayerState.CUED || playerStatus === window.YT.PlayerState.PLAYING) && videoID !== currentVideoIDRef.current) {
            setCurrentVideoID(videoID);
        }
    }

    const loadVideo = async () => {
        if(videoUrl) {
            const videoID = getVideoID(videoUrl);
            if(videoID) {
                player.cueVideoById(videoID, 0);
            }
        }
    }

    const loadPlaylist = async () => {
        if(videoUrl) {
            //it works a bit differently for playlists and videos as we need to be 
            //able to load new subs for each video in the playlist once it starts
            const playlistID = getPlaylistID(videoUrl);
            if(playlistID) {
                setCurrentPlaylistID(playlistID);
            }
        }
    }

    const toggleSelectedLanguage = (language) => {
        let languages = [...selectedLanguages];
        if(languages.includes(language)) {
            languages = languages.filter(l => l !== language);
        }
        else {
            languages.push(language);
        }
        setSelectedLanguages(languages);
    }

    const getVideoID = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length == 11)? match[7] : '';
    }

    const getPlaylistID = (url) => {
        const regExp = /[?&]list=([^#\&\?]+)/;
        const match = url.match(regExp);
        return match[1] || '';
    }
    
    const getSubtitleStyle = () => {
        const contentFrame = containerRef.current;    
        if(contentFrame) {
            const height = contentFrame.offsetHeight;
            const bottomPadding = height < 300 ? 40 : 60;
            const fontSize = height / 300 + "em";
            const bottom = bottomPadding + "px";
            const style = {
                display: 'block', 
                background: 'rgba(0, 0, 0, 0.8)', 
                padding: '1px 4px', 
                marginBottom: '2px', 
                position: 'absolute',
                zIndex: 10000000,
                fontSize,
                bottom
            }
            if(isFullScreen) {
                const fullScreenSpan = document.getElementById('fullScreenSpan');
                const fullScreenSpanHeight = fullScreenSpan ? fullScreenSpan.offsetHeight : 0;
                style.background = 'rgba(0, 0, 0, 0.7)';
                style.width = '98%';
                style.bottom = null;
                //set this to below the span
                style.top = fullScreenSpanHeight + 'px';
                style.textAlign = 'center';
                style.fontSize = height / 350 + "em";
            }
            else if(contentFrame.offsetWidth > 600) {
                style.left = '50%';
                style.transform = 'translate(-50%, -50%)';
            }
            else {
                style.width = '98%';
                style.textAlign = 'center';
            }
            return style;
        }
    }

    const getSubtitleColor = (index) => {
        const colors = ['#fff', 'goldenrod', '#85b9ee'];
        return colors[index % colors.length];
    }

    return (
        <div>
            <Card style={{minWidth: '18rem', marginBottom: '30px'}}>
                <Card.Header>
                    <Card.Title>Video Preview</Card.Title>
                </Card.Header>
                <Card.Body style={{textAlign: 'center'}}>     
                    <Card.Text>
                        YouTube Link: <input type="text" value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} style={{minWidth: 500}} />
                    </Card.Text>       
                    <Card.Text>
                        <input type="button" onClick={loadVideo} disabled={!playerReady} value="Load Video" />&nbsp;
                        <input type="button" onClick={loadPlaylist} disabled={!playerReady} value="Load Playlist" />
                    </Card.Text>         
                    <div style={{ width: '70%', padding: '0 15px', maxHeight: '700px', margin: '0 auto' }}>
                        <div>Preview Video</div>
                        <div id="container" ref={containerRef} style={{display: currentVideoID || currentPlaylistID ? 'block': 'none', minHeight: '500px'}}>
                            <div style={{position: 'absolute'}}>
                               <span id="fullScreenSpan" onClick={() => setIsFullScreen(!isFullScreen)} style={{color: '#fff', backgroundColor: '#6c757d', padding: '0 4px', marginRight: '1px', cursor: 'pointer'}}>{isFullScreen ? 'Cancel full screen' : 'Make full screen'}</span>
                             {
                                allLanguages.map(language => <span 
                                    key={language} 
                                    style={{
                                        color: selectedLanguages.includes(language) ? 'black' : '#fff', 
                                        backgroundColor: selectedLanguages.includes(language) ? '#fff' : '#6c757d', 
                                        padding: '0 5px', 
                                        marginRight: '1px',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => toggleSelectedLanguage(language)}>{language}</span>)
                             }
                            </div>
                            <div id="player" style={{width: '100%', height: '100%', minHeight: '500px'}} />
                            {
                                !!currentSubtitles.length && !!selectedLanguages.length && <span id="subtitleText" style={subtitleStyle}>
                                {
                                  currentSubtitles.map((currentSubtitleText, index) => 
                                    <span key={index} style={{display:'block', color: getSubtitleColor(index) }}>{currentSubtitleText}</span>
                                  )
                                }
                              </span>
                            }
                        </div>
                    </div>
                  
                </Card.Body>
                <Card.Footer>
                    <Link to={'/'}>
                        Back
                    </Link>
                </Card.Footer>
            </Card> 
        </div>
    );
}

export default PreviewPage;
